import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FacebookModule } from 'ngx-facebook';
import { TranslatePipesModule } from '../shared/translate-pipes.module';
import { SocialShareComponent } from './social-share.component';

@NgModule({
  imports: [
    CommonModule,
    FacebookModule.forRoot(),
    TranslatePipesModule,
  ],
  exports: [
    SocialShareComponent,
  ],
  declarations: [
    SocialShareComponent,
  ],
})
export class SocialShareModule {
}
